<div class="card bg-card-new card-radius-06 border-0">
    <app-active-quotations class="p-4"></app-active-quotations>
</div>
